import { getParsedIntegersFromPeriodString } from '../utils/helpers'
import { Attrs, Options, StoslConfig } from './configs/stosl'
import Stochastics from './stofu'

class StochasticsSlow extends Stochastics<Attrs> {
  static config = StoslConfig

  kPeriod = 3

  set(values: Partial<Attrs>) {
    if (typeof values.period === 'string') {
      const [period = 0, dPeriod = 0] = getParsedIntegersFromPeriodString(values.period)
      super.set({ ...values, period, dPeriod, kPeriod: 3 })
    } else {
      super.set(values)
    }
  }

  getModalConfig() {
    const options = {
      period: {
        type: 'number',
        label: 'Period',
        name: 'period',
        value: this.period ?? 14,
        required: true,
        min: 1,
        max: 999999,
      },
      dPeriod: {
        type: 'number',
        label: 'D Period',
        name: 'dPeriod',
        value: this.dPeriod ?? 3,
        required: true,
        min: 1,
        max: 999999,
      },
    }

    return {
      title: StoslConfig.label,
      inputs: StoslConfig.inputsOrder.map((item) => options[item as keyof Options]),
      inputsErrorMessages: {
        period: `${options.period.label} must be a whole number between ${options.period.min} and ${options.period.max}`,
        dPeriod: `${options.dPeriod.label} must be a whole number between ${options.dPeriod.min} and ${options.dPeriod.max}`,
      },
    }
  }

  getIsValid(key: string): boolean {
    switch (key) {
      case 'period':
      case 'dPeriod':
        return this.getIsNumberInputValid({ key })
      default:
        return false
    }
  }
}

export default StochasticsSlow
